module.exports = __webpack_public_path__ + "static/media/icon-import.240776c4.svg";